import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Accueil ${ctx.brand}`,
    languageButtonLabel: `Langue`,
    languageModalTitle: `Choisis ta langue`,
    languageModalCloseLabel: `Fermer le menu des langues`,
  },
  languageOptions: {
    'en-US': {
      label: `Anglais/États-Unis`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Anglais/Kenya`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Anglais/Nigéria`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Anglais/Singapour`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugais/Portugal`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugais/Brésil`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Allemand/Allemagne`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Allemand/Autriche`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Allemand/Suisse`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Espagnol/Espagne`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Français/France`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italien/Italie`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Néerlandais/Pays-Bas`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polonais/Pologne`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Suédois/Suède`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danois/Danemark`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finlandais/Finlande`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norvégien/Norvège`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandais/Islande`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonais/Japon`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coréen/Corée du Sud`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarin/Chine`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonais/Hong Kong`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamien/Vietnam`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thaï/Thaïlande`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonésien/Indonésie`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili/Kenya`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi/Inde`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali/Bangladesh`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi/Inde`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Télougou/Inde`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persan/Iran`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Ourdou/Pakistan`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Pendjabi/Pakistan`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin nigérian/Nigéria`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russe/Russie`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabe du Golfe/Arabie saoudite`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabe/Émirats arabes unis`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabe/Qatar`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Arabe marocain/Maroc`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Choisis ta langue`,
    closeLabel: `Fermer le menu des langues`,
  },
  languageHint: (ctx) => `Bascule entre plus de ${ctx.localesCount}+ langues.`,
  readPagePrompt: ({languageLabel}) => `Lis cette page en ${languageLabel}.`,
};
